// @core/api/endpoints/task/get_dependency_graph.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetDependencyGraphResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get dependency graph
 * Returns the full dependency graph for tasks within a scope. Includes nodes (tasks with status) and edges (dependencies with type). Supports filtering by parent entity to get a project-scoped graph. Used for visualization, topological ordering, and critical path analysis.
 */
export async function GetDependencyGraph(
  params?: {
  },
  options?: RequestOptions
): Promise<GetDependencyGraphResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tasks/dependency-graph`;
  const requestOptions = options;
  return client.get<GetDependencyGraphResponse>(requestPath, { ...requestOptions, params });
}
